import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { resolveImg } from "@/lib/api";

// slides: array of strings (legacy) or { image, title, subtitle }
export default function PhotoCarousel({ images = [], interval = 4500, className = "" }) {
  const slides = images
    .map((s) => (typeof s === "string" ? { image: s, title: "", subtitle: "" } : s))
    .filter((s) => s && s.image);
  const [i, setI] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return;
    const t = setInterval(() => setI((p) => (p + 1) % slides.length), interval);
    return () => clearInterval(t);
  }, [slides.length, interval]);

  if (!slides.length) return null;
  const current = slides[i];

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} data-testid="photo-carousel">
      <AnimatePresence mode="sync">
        <motion.img
          key={i}
          src={resolveImg(current.image)}
          alt={current.title || "VM Piabetá Shopping Center"}
          initial={{ opacity: 0, scale: 1.08 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ opacity: { duration: 1.1 }, scale: { duration: interval / 1000 + 1, ease: "linear" } }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </AnimatePresence>

      {(current.title || current.subtitle) && (
        <div className="absolute bottom-28 sm:bottom-20 left-1/2 -translate-x-1/2 z-20 w-full max-w-3xl px-6 text-center pointer-events-none">
          <AnimatePresence mode="wait">
            <motion.div
              key={`caption-${i}`}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}
            >
              {current.title && (
                <p className="font-serif text-xl sm:text-2xl lg:text-3xl leading-snug drop-shadow-lg" data-testid="carousel-caption-title">
                  {current.title}
                </p>
              )}
              {current.subtitle && (
                <p className="mt-2 text-sm sm:text-base text-white/85 drop-shadow" data-testid="carousel-caption-subtitle">
                  {current.subtitle}
                </p>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      )}

      {slides.length > 1 && (
        <div className="absolute bottom-24 sm:bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {slides.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              aria-label={`Foto ${idx + 1}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${idx === i ? "w-8 bg-vm-gold" : "w-2 bg-white/50"}`}
              data-testid={`carousel-dot-${idx}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
